import { useEffect, useId, useRef } from 'react'

const APP_NAME = 'Trainrr'

type DocumentTitleEntry = {
  order: number
  priority: number
  title?: string | null
}

type UseDocumentTitleOptions = {
  enabled?: boolean
  priority?: number
}

const titleEntries = new Map<string, DocumentTitleEntry>()
let titleOrder = 0

export function formatDocumentTitle(title?: string | null) {
  const trimmedTitle = title?.trim()
  return trimmedTitle ? `${trimmedTitle} | ${APP_NAME}` : APP_NAME
}

function applyDocumentTitle() {
  const currentEntry = [...titleEntries.values()].sort(
    (a, b) => b.priority - a.priority || b.order - a.order,
  )[0]

  document.title = formatDocumentTitle(currentEntry?.title)
}

export function useDocumentTitle(
  title?: string | null,
  options: UseDocumentTitleOptions = {},
) {
  const id = useId()
  const orderRef = useRef<number>(0)

  if (!orderRef.current) {
    titleOrder += 1
    orderRef.current = titleOrder
  }

  useEffect(() => {
    if (options.enabled === false) {
      titleEntries.delete(id)
      applyDocumentTitle()
      return
    }

    titleEntries.set(id, {
      order: orderRef.current,
      priority: options.priority ?? 1,
      title,
    })
    applyDocumentTitle()

    return () => {
      titleEntries.delete(id)
      applyDocumentTitle()
    }
  }, [id, options.enabled, options.priority, title])
}
